export const maxTooltipTimesShown = 10;
